// TEMPORARY SOLUTION: These utilities extract version information from unique_id strings
// In the future, we will add explicit version fields to models in the report data
// to support model versioning more fully and eliminate the need for string parsing

export const extractVersionFromUniqueId = (uniqueId: string): number | null => {
  const versionMatch = uniqueId.match(/\.v(\d+)$/);
  return versionMatch ? parseInt(versionMatch[1], 10) : null;
};

export const isNewerVersion = (
  modelA: { unique_id: string },
  modelB: { unique_id: string },
): boolean => {
  const versionA = extractVersionFromUniqueId(modelA.unique_id);
  const versionB = extractVersionFromUniqueId(modelB.unique_id);

  if (versionA !== null && versionB !== null) {
    return versionA > versionB;
  }

  if (versionA !== null && versionB === null) {
    return true;
  }
  if (versionA === null && versionB !== null) {
    return false;
  }

  // For non-versioned models, use localeCompare for more robust comparison
  return modelA.unique_id.localeCompare(modelB.unique_id) > 0;
};

export const deduplicateVersionedModels = <T extends { unique_id: string }>(
  models: T[],
  keyExtractor: (model: T) => string,
): T[] => {
  const modelMap = new Map<string, T>();

  for (const model of models) {
    const key = keyExtractor(model);
    const existing = modelMap.get(key);

    if (!existing) {
      modelMap.set(key, model);
    } else {
      if (isNewerVersion(model, existing)) {
        modelMap.set(key, model);
      }
    }
  }

  return Array.from(modelMap.values());
};
